export default __webpack_public_path__ + "static/media/auth-purple-card.f8fb8b2f.svg";